import { getLiveTagValue } from "@/features/datapoints/api/getLiveTagValue.ts"

import type { FlowRateDisplayData } from "../../types/flowRateDisplayTypes.ts"

export const getFlowRateDisplayData = async (): Promise<FlowRateDisplayData> => {
  const values = await Promise.all([
    getLiveTagValue("PLTH_Samsara_Imports/Inlet/Inlet Gas Flow"),
    getLiveTagValue("PLTH_Samsara_Imports/GC/GC_Inlet/Gas Componets/Methane"),
    getLiveTagValue("PLTH_Samsara_Imports/Sales/Sales Gas Flow"),
    getLiveTagValue("PLTH_Samsara_Imports/Sales/Sales Methane"),
    getLiveTagValue("default/BCO/Live/Plant Status"),
  ])

  return {
    inletSCFM: values[0] / 1.44, // Converting MSCF to SCFM
    inletCH4: values[1],
    outletSCFM: values[2] / 1.44, // Converting MSCF to SCFM
    outletCH4: values[3],
    online: values[2] > 0,
  }
}
